import CustomSwitch from "./custom-switch.component";
export default CustomSwitch;
